module.exports = __webpack_public_path__ + "static/img/map.9465851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/map.png
// module id = Hnad
// module chunks = 0